import React, { useMemo } from "react";
import { Modal, Button, List, Card, Tag, Space, Typography, Empty } from "antd";
import {
  ClockCircleOutlined,
  EnvironmentOutlined,
  FileTextOutlined,
  UserOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";

const { Text } = Typography;

// ✅ ผลการขาย (ให้ตรงกับ SaleResultModal)
const SALE_RESULT_META = {
  1: { label: "ราคาขาย", color: "green" },
  2: { label: "งดการขาย", color: "orange" },
  3: { label: "ยกเลิกการขาย", color: "red" },
};

// ✅ แปลงวันที่เป็นไทย (พ.ศ.) แบบ self-contained
const TH_MONTHS = [
  "มกราคม",
  "กุมภาพันธ์",
  "มีนาคม",
  "เมษายน",
  "พฤษภาคม",
  "มิถุนายน",
  "กรกฎาคม",
  "สิงหาคม",
  "กันยายน",
  "ตุลาคม",
  "พฤศจิกายน",
  "ธันวาคม",
];
const thaiDate = (d) => {
  if (!d) return "-";
  const x = dayjs(d);
  return `${x.date()} ${TH_MONTHS[x.month()]} ${x.year() + 543}`;
};

const apptStatus = (d) =>
  dayjs(d).isAfter(dayjs())
    ? { label: "กำลังจะมาถึง", color: "red" }
    : { label: "ผ่านมาแล้ว", color: "green" };

const SaleAppointmentData = ({ open, close, dataRec = [], date }) => {
  const list = useMemo(
    () =>
      [...dataRec].sort(
        (a, b) => dayjs(a.date).valueOf() - dayjs(b.date).valueOf(),
      ),
    [dataRec],
  );

  return (
    <Modal
      title={`นัดประมูลขายทอดตลาด — ${thaiDate(date)}`}
      open={open}
      onCancel={close}
      width={640}
      footer={[
        <Button key="close" onClick={close}>
          ปิด
        </Button>,
      ]}
      destroyOnHidden
    >
      {list.length === 0 ? (
        <Empty description="ไม่มีนัดประมูลในวันนี้" />
      ) : (
        <List
          dataSource={list}
          rowKey={(item) => item.eventId}
          renderItem={(item) => {
            const st = apptStatus(item.date);
            const result = item.result
              ? SALE_RESULT_META[item.result.resultType]
              : null;
            const isSold = item.result?.resultType === 1;
            return (
              <Card size="small" style={{ marginBottom: 12 }} hoverable>
                <Space direction="vertical" size={4} style={{ width: "100%" }}>
                  <Space size={8} wrap>
                    <ClockCircleOutlined style={{ color: "#1890ff" }} />
                    <Text strong>{dayjs(item.date).format("HH:mm")} น.</Text>
                    <Tag color="purple">นัดที่ {item.round}</Tag>
                    <Tag color={st.color}>{st.label}</Tag>
                    {result && (
                      <Tag color={result.color}>
                        {result.label}
                        {isSold &&
                          `: ${Number(item.result.price).toLocaleString(
                            "th-TH",
                          )} บาท`}
                      </Tag>
                    )}
                  </Space>

                  <Space size={6} wrap>
                    <FileTextOutlined style={{ color: "#888" }} />
                    <Text strong copyable>
                      {item.contno}
                    </Text>
                    {item.lotNo && <Tag>Lot {item.lotNo}</Tag>}
                  </Space>

                  <Space size={6} wrap>
                    <UserOutlined style={{ color: "#888" }} />
                    <Text type="secondary">{item.customerName || "-"}</Text>
                  </Space>

                  {item.province && (
                    <Space size={6} wrap>
                      <EnvironmentOutlined style={{ color: "#888" }} />
                      <Text type="secondary">{item.province}</Text>
                    </Space>
                  )}
                </Space>
              </Card>
            );
          }}
        />
      )}
    </Modal>
  );
};

export default SaleAppointmentData;
